/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { Space } from 'antd'
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import styles from './index.less'
import { PlatformList } from '@/components/PlatformList'
import { RefreshListButton } from '@/components/PlatformList/RefreshListButton'
import { TPlatformListService } from '@/components/PlatformList/interface'
import { LayoutOthers } from '@/layouts/LayoutOthers'
import { ContractCard } from '@/pages/contract/Contracts/ContractCard'
import { isProtonBase, officialSite } from '@/process.env'
import { service } from '@/services/service'

export function Contracts() {
  const { t } = useTranslation()
  const [showAlert, setShowAlert] = useState(false)
  const emitter = PlatformList.useCreateEmitter()

  const contractListService: TPlatformListService = () => {
    return service.getContractsWithBillingUpgradeNotification().then(res => {
      setShowAlert(res.length > 0)
      return { data: { items: res } }
    })
  }

  return (
    <LayoutOthers.MainContent
      title={
        <Space>
          <span>{t('Contracts')}</span>
          {/*<VoucherTips />*/}
        </Space>
      }
    >
      {showAlert && <LayoutOthers.Alert className="margin-bottom-20">{t('contract_desc')}</LayoutOthers.Alert>}
      <PlatformList
        emitter={emitter}
        service={contractListService}
        createTitle={() => (
          <>
            <RefreshListButton />
            {/* 已删除新建合约按钮 */}
          </>
        )}
        emptyProps={{
          description: (
            <span className={styles.emptyDescription}>
              <div>{t('contract_desc')}</div>
              {isProtonBase && (
                <Trans i18nKey="refer_documentation_desc">
                  Please refer to the{' '}
                  <a href={`${officialSite}/docs`} target="_blank">
                    documentation
                  </a>{' '}
                  for more information.
                </Trans>
              )}
            </span>
          ),
        }}
        createTiles={contractList => (
          <div className={styles.list}>
            {contractList.map(item => (
              <ContractCard key={item.id} contract={item} />
            ))}
          </div>
        )}
      />
    </LayoutOthers.MainContent>
  )
}
